<template>
    <b-card no-body style="border: none; height: 100%; margin: 0;">
        <b-table no-provider-paging striped bordered hover responsive id="my-table" :items="tableData"
                 :per-page="perPage"
                 :current-page="currentPage"
                 tbody-tr-class="test"
                 :fields="fields" v-on:row-clicked="rowClicked"
                 class="custom-auto-height">
            <template v-slot:cell(seen_by)="row" v-if="row.item.art === 'AF'">
                <circle-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red" v-if="!row.item.seen_by.includes(userId)"></circle-icon>
            </template>
            <template v-slot:cell(offen)="row" v-if="row.item.art === 'AF' || row.item.art === 'DE'">
                <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
                <book-open-page-variant-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red" v-if="row.item.offen === 0 && row.item.art === 'AF'"></book-open-page-variant-icon>
                <schedule-icon class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: green" v-if="row.item.offen === 1 && row.item.art === 'AF'"></schedule-icon>
                <check-bold-icon class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: green" v-if="row.item.offen === 2 && row.item.art === 'AF'"></check-bold-icon>
                <close-circle-icon class="icon-1_5x" fillColor="#ac121b" style="color: red" :size="72" v-if="row.item.art === 'DE'"></close-circle-icon>
            </template>
            <template v-slot:cell(details)="row">
                <b-button variant="primary" size="sm" v-if="!row.detailsShowing" @click="row.toggleDetails">
                    <i class="fa fa-chevron-down"></i>
                </b-button>
                <b-button variant="primary" size="sm" v-if="row.detailsShowing" @click="row.toggleDetails">
                    <i class="fa fa-chevron-up"></i>
                </b-button>
            </template>

            <template #row-details="row">
                <b-row>
                    <b-col>
                        <b-card class="mb-0">
                            <template #header>
                                <strong>Details</strong>
                            </template>
                            <b-row >
                                <b-col md="8">
                                    <p><b>Anfragentext:</b></p>
                                    <span style="white-space: pre-line">{{row.item.message}}</span>
                                </b-col>
                                <b-col >
                                    <b-row><p><b>Anhänge: </b>
                                        <a style="margin-left: 15px"
                                           v-for="item in (row.item.attachments === null ? '' : row.item.attachments).split(';')"
                                           v-if="item !== ''"
                                           target="_blank"
                                           v-on:click.prevent="showFile(url + '/auftragsbuch/upload/file/'+row.item.id+'?file_name='+encodeURIComponent(item)+'&file_type=A', row.item, item)"
                                           :href="url + '/auftragsbuch/upload/file/'+row.item.id+'?file_name='+encodeURIComponent(item)+'&file_type=A'">
                                            {{item}};
                                        </a></p></b-row>
                                    <b-row v-if="row.item.lat !== 0.0 && row.item.lon !== 0.0"><p><b>Position: </b>
                                        <a style="margin-left: 15px"
                                           target="_blank"
                                           :href="gpsLink(row.item)">Zur Position
                                        </a></p></b-row>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3">
                                <b-col md="10"></b-col>
                                <b-col class="text-right">
                                    <b-button variant="primary" class="btn-pill" v-on:click="rowClicked(row.item)">
                                        &nbsp;Zur Anfrage
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </template>
        </b-table>
        <div class="mt-3 custom-flex-0">
            <b-pagination v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          aria-controls="my-table" align="center"></b-pagination>
        </div>
    </b-card>
</template>

<script>
    import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
    import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
    import ScheduleIcon from 'vue-material-design-icons/Clock.vue';
    import CloseCircleIcon from 'vue-material-design-icons/CloseCircle';
    import CircleIcon from 'vue-material-design-icons/Circle';
    import {Server_URL, Server_URL_MAENGELMELDER} from "../../shared/utils";
    import {arrayBufferToBase64, decryptFile} from "../../shared/crypto";


    export default {
        name: 'AnfragenTable',
        components: {
            BookOpenPageVariantIcon, CheckBoldIcon, ScheduleIcon, CloseCircleIcon, CircleIcon
        },
        props:{
            tableData: {
                type: Array,
                default: () => []
            },
            rowClickCallback: {
                type: Function,
                default: undefined
            },
            allGroups: {
                type: Object,
                default: () => {}
            },

        },
        mounted() {
            this.userId = this.$cookies.get("ps_user_id");
          this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
        },
        data: () => {
            return {
              isBauhof: false,
              filename: "",
                fields: [
                    //{key: 'seen_by', label: ''},
                    {key: 'offen', label:"Status"},
                    {key: 'title', label:"Titel"},
                    {key: 'sender_group', label:"Anfragensteller", formatter: 'formateAnfragenSteller'},
                    {key: 'create_date', label:"Anfragendatum", formatter: "dateToString"},
                    {key: 'accepting_group', label:"Annahme von", formatter: "formateAcceptingGroup"},
                    {key: 'accept_date', label:"Annahme am", formatter: "dateToString"},
                    {key: 'finishing_group', label:"Fertiggestellt von", formatter: "formateFinishingGroup"},
                    {key: 'finish_date', label:"Fertiggestellt am", formatter: "dateToString"},
                    {details: "Details"}
                ],
                currentPage: 1,
                perPage: 20,
                url: Server_URL,
                urlMm: Server_URL_MAENGELMELDER,
                userId: "",
            }
        },
        computed: {
            items: function() {
                const items =  this.tableData;
                return Array.isArray(items) ? items : items()
            },
            rows() {
                return this.tableData.length
            }
        },
        methods: {
            rowClicked(item, index, target) {
              if(item.art === "DE" || (item.art === "AF" && item.offen === 0)) {
                this.$router.push("/auftraege/auftrag/" + item.id + "?force_anfrage=true");
              } else {
                this.$router.push("/auftraege/auftrag/" + item.id);
              }

                if (this.rowClickCallback !== undefined) {
                    this.rowClickCallback(item, index);
                }
            },
            dateToString(value) {
                if (value === null) {
                    return ""
                }
                let event = new Date(value.replace('Z',''));
                let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                return event.toLocaleDateString('de-DE', options);
            },
            formateMemo(value) {
                if (value === null) {
                    return "";
                }
                if (value.length > 80)
                    return value.substring(0,80) + '...';
                else
                    return value;
            },
            formateMoney(value) {
                if (value === null) {
                    return "";
                }
                return ""+value+" €"
            },
            showFile(href, item, filename) {
              this.filename = filename;
                if (sessionStorage.getItem("aes") !== null && (item.module !== "mm" || this.isBauhof)) {
                    this.$http.get(
                        href, {responseType: 'blob'}
                    ).then(this.onFileOk, this.responseError)
                } else {
                    window.open(href, "_blank")
                }
            },
            onFileOk(response) {
                response.blob().then(blob => {
                    blob.arrayBuffer().then(binary => {
                        decryptFile(sessionStorage.getItem("aes"), new Uint8Array(binary)).then(res => {
                          if (this.isBauhof) {
                            try {
                              windowsFileService.onFile(
                                  arrayBufferToBase64(res),
                                this.filename,
                                blob.type
                              ).then(r => {
                                if (r && !r.Success) {
                                  console.log(r)
                                }
                              }).catch(e => {
                                console.log(e)
                              });
                            } catch (e) {
                              console.log(e);
                            }
                            return
                          }
                          const b = new Blob([res], {type: blob.type});
                            const blobUrl = URL.createObjectURL(b);
                            window.open(blobUrl, '_blank');
                        }).catch(err => {
                          if (this.isBauhof) {
                            try {
                              windowsFileService.onFile(
                                  arrayBufferToBase64(binary),
                                this.filename,
                                blob.type
                              ).then(r => {
                                if (r && !r.Success) {
                                  console.log(r)
                                }
                              }).catch(e => {
                                console.log(e)
                              });
                            } catch (e) {
                              console.log(e);
                            }
                            return
                          }
                            const blobUrl = URL.createObjectURL(blob);
                            window.open(blobUrl, '_blank');
                        })
                    })
                });
            },
            responseError(response) {
                console.log(response)
            },
            gpsLink(item) {
                return Server_URL_MAENGELMELDER + "/#/location/show?lat="+item.lat+"&lon="+item.lon
            },
            formateAnfragenSteller(value, key, item) {
                if (item === null) {
                    return null;
                }
                if (item.sender_group === "mm") {
                    return "Mängelmelder"
                }
                if (item.sender_user !== "") {
                    let res = JSON.parse(sessionStorage.getItem(item.sender_user));
                    if (res === null) {
                        return value;
                    }
                    return res.first_name + " " + res.surname;
                } else if (item.sender_group !== "" && item.sender_group in this.allGroups) {
                    return this.allGroups[item.sender_group];
                } else {
                    return value;
                }
            },
            formateAcceptingGroup(value, key, item) {
                if (item === null) {
                    return null;
                }
                if (item.accepting_user !== "") {
                    let res = JSON.parse(sessionStorage.getItem(item.accepting_user));
                    if (res === null) {
                        return value;
                    }
                    return res.first_name + " " + res.surname;
                } else if (item.accepting_group !== "" && item.accepting_group in this.allGroups) {
                    return this.allGroups[item.accepting_group];
                } else {
                    return value;
                }
            },
            formateFinishingGroup(value, key, item) {
                if (item === null) {
                    return null;
                }
                if (item.finishing_user !== "") {
                    let res = JSON.parse(sessionStorage.getItem(item.finishing_user));
                    if (res === null) {
                        return value;
                    }
                    return res.first_name + " " + res.surname;
                } else if (item.finishing_group !== "" && item.finishing_group in this.allGroups) {
                    return this.allGroups[item.finishing_group];
                } else {
                    return value;
                }
            }
        }
    }
</script>

<style scoped>

</style>

